"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectFilterDropdown = void 0;
var React = require("react");
var react_popper_1 = require("react-popper");
var utils_1 = require("../../../_Core/utils");
var Highlighted_1 = require("../../../Highlighted");
var Indicators_1 = require("../../../Indicators");
var DropList_1 = require("../../../Lists/DropList");
var Localization_1 = require("../../../Localization");
var setAnnouncement_1 = require("../../../setAnnouncement/setAnnouncement");
var FilterBar_context_1 = require("../FilterBar.context");
var AddFilterButton_1 = require("./AddFilterButton");
var DisplayFilterButton_1 = require("./DisplayFilterButton");
var SelectFilterDropdown = function (_a) {
    var OnSelected = _a.OnSelected, OnRemove = _a.OnRemove, Filter = _a.Filter;
    var _b = React.useState(), dropdownData = _b[0], setDropdownData = _b[1];
    var _c = React.useState(Filter.ShowOptions), visible = _c[0], setVisible = _c[1];
    var _d = React.useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var buttonRef = React.createRef();
    var OnFilterTypeAdd = FilterBar_context_1.useFilterBarContext().OnFilterTypeAdd;
    var handleItemRemove = function () {
        OnRemove(Filter);
    };
    var handlePickFilter = function () {
        setVisible(true);
        setIsLoading(true);
        OnFilterTypeAdd(Filter).then(function (result) {
            setDropdownData(result);
            setIsLoading(false);
        });
    };
    var handleCompleted = function (items) {
        setVisible(false);
        OnSelected(Filter, items);
        if (buttonRef.current) {
            buttonRef.current.focus();
        }
    };
    React.useEffect(function () {
        if (OnFilterTypeAdd) {
            setIsLoading(true);
            OnFilterTypeAdd(Filter).then(function (result) {
                setDropdownData(result);
                setIsLoading(false);
            });
        }
    }, []);
    return (React.createElement(react_popper_1.Manager, null,
        React.createElement(react_popper_1.Reference, null, function (_a) {
            var ref = _a.ref;
            return (React.createElement("div", { ref: ref },
                React.createElement(DisplayFilterButton_1.DisplayFilterButton, { ref: buttonRef, DropdownVisible: visible, OnRemove: handleItemRemove, OnPickFilter: handlePickFilter, Active: visible, Caption: Filter.Name, Value: Filter.Value })));
        }),
        React.createElement(react_popper_1.Popper, { placement: "bottom-start" }, function (_a) {
            var ref = _a.ref, style = _a.style;
            return (React.createElement("div", { ref: ref, style: __assign(__assign({}, style), { zIndex: 2 }) }, visible &&
                (isLoading ? (React.createElement(DropList_1.DropList, null,
                    React.createElement(DropList_1.DropListItem, { OnClick: function () {
                            /*Empty*/
                        }, Title: Localization_1.strings.Label_Loading },
                        React.createElement(Indicators_1.AreaLoader, null)))) : (dropdownData && (React.createElement(ListPicker, { Filter: Filter, Data: dropdownData, OnCompleted: handleCompleted }))))));
        })));
};
exports.SelectFilterDropdown = SelectFilterDropdown;
function useOutsideAlerter(ref, onClick) {
    React.useEffect(function () {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                onClick();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}
var ListPicker = function (_a) {
    var Filter = _a.Filter, Data = _a.Data, OnCompleted = _a.OnCompleted;
    var _b = React.useState(Filter.Value ? __spreadArray([], Filter.Value) : []), selectedItems = _b[0], setSelectedItems = _b[1];
    var _c = React.useState(""), searchString = _c[0], setSearchString = _c[1];
    var containerRef = React.createRef();
    var sayPolitely = setAnnouncement_1.setAnnouncement().sayPolitely;
    var orderByCaption = function (dataSource) {
        var hasEmptyCaption = dataSource.find(function (i) { var _a; return !i.Caption || !((_a = i.Caption) === null || _a === void 0 ? void 0 : _a.length); });
        if (hasEmptyCaption) {
            var dataWithEmptyCaption_1 = [];
            var filteredData = dataSource.filter(function (i) {
                var _a;
                if (!i.Caption || !((_a = i.Caption) === null || _a === void 0 ? void 0 : _a.length)) {
                    dataWithEmptyCaption_1.push(__assign(__assign({}, i), { Caption: Localization_1.strings.FilterBar_Label_NotProvided }));
                    return false;
                }
                return true;
            });
            return filteredData.concat(dataWithEmptyCaption_1);
        }
        return dataSource;
    };
    var _d = React.useState(orderByCaption(Data)), data = _d[0], setData = _d[1];
    useOutsideAlerter(containerRef, function () { return OnCompleted(selectedItems); });
    var handleOnCloseMenu = function () {
        OnCompleted(Filter.Value);
    };
    var handleSelectSingleItem = function (item) {
        OnCompleted([item]);
    };
    var handleMultipleClick = function (checked, item) {
        if (checked) {
            selectedItems.push(item);
            setSelectedItems(__spreadArray([], selectedItems));
        }
        else {
            var index = selectedItems.findIndex(function (e) { return e.Value === item.Value; });
            selectedItems.splice(index, 1);
            setSelectedItems(__spreadArray([], selectedItems));
        }
    };
    var isItemSelected = function (item) {
        var isSelected = selectedItems.find(function (e) { return e.Value === item.Value; }) !== undefined;
        return isSelected;
    };
    var handleOnConfirmClick = function () {
        OnCompleted(selectedItems);
    };
    var handleSearched = function (search) {
        var regex = RegExp(search, "ig");
        var newData = orderByCaption(Data)
            .filter(function (e) { return e.Caption; })
            .filter(function (e) { return e.Caption.match(regex); });
        setSearchString(search);
        setData(newData);
        sayPolitely(utils_1.getResultCountMessage(newData.length));
        return Promise.resolve();
    };
    var handleSearchCancelled = function () {
        setSearchString("");
        setData(Data);
        return Promise.resolve();
    };
    return (React.createElement("div", { ref: containerRef },
        React.createElement(DropList_1.DropList, { MaxHeight: 400, ShowConfirm: Filter.Multiple, ConfirmCaption: Localization_1.strings.Action_Close, ShowSearch: Data.length > 8, OnSearch: handleSearched, OnSearchCancel: handleSearchCancelled, OnConfirmClick: handleOnConfirmClick, OnCloseMenu: handleOnCloseMenu }, data.length > 0 ? (data.map(function (item) {
            return !Filter.Multiple ? (React.createElement(DropList_1.DropListItem, { key: item.Value, OnClick: function () { return handleSelectSingleItem(item); }, Selected: isItemSelected(item) },
                React.createElement(Highlighted_1.Highlighted, { Text: item.Caption ? item.Caption : "", Highlight: searchString }))) : (React.createElement(DropList_1.DropListItemCheckbox, { key: item.Value, Value: isItemSelected(item), OnClick: function (checked) { return handleMultipleClick(checked, item); } },
                React.createElement(Highlighted_1.Highlighted, { Text: item.Caption ? item.Caption : "", Highlight: searchString })));
        })) : (React.createElement(AddFilterButton_1.NoneFound, null)))));
};
